import { render, staticRenderFns } from "./EditChannel.vue?vue&type=template&id=39363367&scoped=true&"
import script from "./EditChannel.vue?vue&type=script&lang=js&"
export * from "./EditChannel.vue?vue&type=script&lang=js&"
import style0 from "./EditChannel.vue?vue&type=style&index=0&id=39363367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39363367",
  null
  
)

export default component.exports